// src/components/common/LogDateFilter.jsx
import React, { useState } from 'react';
import { Button } from '../ui/button';
import FormField from '../common/FormField';
import { Calendar, Clock } from 'lucide-react';

const initialFilters = {
  date_range: '',
  start_date: '',
  end_date: '',
  from_datetime: '',
  to_datetime: '',
};

const LogDateFilter = ({ onFilter }) => {
  const [filters, setFilters] = useState(initialFilters);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleDateRangeChange = (value) => {
    setFilters((prev) => ({ ...prev, date_range: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onFilter(filters);
  };

  const handleReset = () => {
    setFilters(initialFilters);
    onFilter(initialFilters); // optional: reset results immediately
  };

  const dateRanges = [
    { value: '', label: 'Custom' },
    // { value: 'today', label: 'Today' },
    // { value: 'this_week', label: 'This Week' },
    // { value: 'this_month', label: 'This Month' },
    // { value: 'this_year', label: 'This Year' },


    { "label": "Today", "value": "today" },
  { "label": "Yesterday", "value": "yesterday" },
  { "label": "Last 7 Days", "value": "last_7_days" },
  { "label": "Last 30 Days", "value": "last_30_days" },
  { "label": "Last 3 Months", "value": "last_3_months" },
  { "label": "Last 6 Months", "value": "last_6_months" },
  { "label": "This Month", "value": "this_month" },
  { "label": "Last Month", "value": "last_month" },
  { "label": "This Year", "value": "this_year" },
  { "label": "Last Year", "value": "last_year" }
  ];

  return (
    <form onSubmit={handleSubmit} className="space-y-4 bg-card p-4 rounded-lg border">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <FormField
          label="Date Range"
          type="select"
          value={filters.date_range}
          onChange={(e) => handleDateRangeChange(e.target.value)}
          options={dateRanges}
          placeholder="Select range"
        />

        <FormField
          label="Start Date"
          name="start_date"
          type="date"
          value={filters.start_date}
          onChange={handleChange}
          icon={<Calendar className="h-4 w-4" />}
        />

        <FormField
          label="End Date"
          name="end_date"
          type="date"
          value={filters.end_date}
          onChange={handleChange}
          icon={<Calendar className="h-4 w-4" />}
        />

        {/* <FormField
          label="From Datetime"
          name="from_datetime"
          type="datetime-local"
          value={filters.from_datetime}
          onChange={handleChange}
          icon={<Clock className="h-4 w-4" />}
        />

        <FormField
          label="To Datetime"
          name="to_datetime"
          type="datetime-local"
          value={filters.to_datetime}
          onChange={handleChange}
          icon={<Clock className="h-4 w-4" />}
        /> */}
      </div>

      <div className="flex justify-end gap-2">
        <Button type="button" variant="outline" onClick={handleReset}>
          Reset
        </Button>
        <Button type="submit">Apply Filters</Button>
      </div>
    </form>
  );
};

export default LogDateFilter;
